import $ from "../../../node_modules/cash-dom/dist/cash.esm.js";
import dialogPolyfill from "../../../node_modules/dialog-polyfill/dist/dialog-polyfill.esm.js";

$("dialog", document).each((_index, dialog) => {
  dialogPolyfill.registerDialog(dialog);
});
